export var videoEvaluator = function (video) {
    return Boolean(video.headline && video.description && video.videoId);
};
